<div class="breadcrumbs">
  <ul>
    <li *ngFor="let item of breadcrums">
      <span style="font-size: 15px;">&nbsp;</span>
      <a [routerLink]="item.path">
        {{item.text}}
      </a>
      <span style="font-size: 15px;">&nbsp;</span>
    </li>
  </ul>
</div>
